const R = require('ramda')

export default function (mappingDoc, lhsFields, rhsFields) {
  const lhs = mappingDoc.map(m => m.lhs)
  const rhs = mappingDoc.map(m => m.rhs)
  const defaultValues = mappingDoc.map(m => m.default_value)

  const lhsCount = lhs.length

  const lhsMapped = rhs.map(field => R.isEmpty(field) || R.isNil(field))
  const rhsMapped = rhs.map(field => R.isEmpty(field) || R.isNil(field))
  const defaultValuesMapped = defaultValues.map(val => R.isEmpty(val) || R.isNil(val))

  const counts = R.countBy(Boolean)
  const unmappedCounts = R.compose(R.pathOr(0, [true]), counts)
  const mappedCounts = R.compose(R.pathOr(0, [false]), counts)

  const summary = function () {
    return `${lhsCount} Fields. ${mappedCounts(rhsMapped)} Fields Mapped. ${unmappedCounts(defaultValuesMapped)} Fields missing fallback value`
  }

  const isValid = function () {
    //
    // check all fields lengths the same
    //    check lhs/rhs fields in mapping doc are present in the available Lhs/Rhs Fields List
    //
    if (lhsFields.length === 0) {
      return [false, 'Select an email template']
    }

    const lhsIntersection = R.intersection(lhs, lhsFields || [])
    const rhsIntersection = R.intersection(rhs, rhsFields || [])

    // for sizes, testing lhsFields length because should at least have a single field (email) to be mapped
    const sizes = [lhsFields.length, lhsCount, rhs.length, defaultValues.length, lhsIntersection.length, rhsIntersection.length]
    if (R.uniq(sizes).length !== 1) {
      return [false, 'No fields are mapped or same field mapped twice']
    }

    //
    // check no value is blank or null
    //
    const missingValues = unmappedCounts(lhsMapped) > 0 || unmappedCounts(rhsMapped) > 0
    if (missingValues) {
      return [false, 'Unmapped Values']
    }

    // we made it - good to go
    return [true, null]
  }

  return {
    summary: summary(),
    isValid: isValid()[0],
    warnings: unmappedCounts(defaultValuesMapped),
    summaryError: isValid()[1]
  }
}
